// extracted by mini-css-extract-plugin
module.exports = {"cakeBackground":"CakeBackground_cakeBackground__QAe56","mobile":"CakeBackground_mobile__3EjNe","desktop":"CakeBackground_desktop__1r7RK"};